module.exports = __webpack_public_path__ + "img/pro.2e2afbfb.svg";